export const ROUTES = {
  GLOBAL: "/home",
  STARTUPVIDEO: "/startup-video",
  ABOUT: "/about",
  SIGNIN: "/",
  SIGNUP: "/signup",
  LOGOUT: "/logout",
  CART: "/cart",
  PAYMOB: "/paymob",
  EWALLET: "/e-wallet",
  POSTPAY: "/postpay",
  PRIVACYPOLICY: "/privacy-policy",
  LUCKYHOURS: "/lucky-hours",
  STORE: "/store",
  BIDDERS: "/bidders",
  AUCTION: "/auction",
  BUYANDSUPPLY: "/buy-and-supply",
  BUY: "buy",
  SUPPLY: "supply",
  MERCHANT: "/merchant",
  PARTNERSHIPS: "/partnerships",
  RENT_WAREHOUSE: "/rent-warehouse",
  NOT_FOUND: "*",
};
